export default __webpack_public_path__ + "static/media/signupNewImage.15f0e2ae.png";